<template>
  <div>
    <v-navigation-drawer color="info" v-model="drawer" app right>
      <v-list dense dark>
        <v-list-item link to="/book">
          <v-list-item-action>
            <v-icon>mdi-book</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Kitoblar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/category">
          <v-list-item-action>
            <v-icon>mdi-menu</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Bo'limlar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/department">
          <v-list-item-action>
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Kafedralar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block @click="logOut()" color="primary">CHIQISH</v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app color="info" dark>
      <v-spacer></v-spacer>

      <v-toolbar-title>Admin Panel</v-toolbar-title>

      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>
  </div>
</template>
<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    drawer: false,
  }),
  methods: {
    logOut(){
      window.open("https://library.andqxai.uz","_self")
    }
  },
};
</script>
